import { render } from "./interest-desc-list.vue?vue&type=template&id=e28afd9a&scoped=true"
import script from "./interest-desc-list.vue?vue&type=script&lang=js"
export * from "./interest-desc-list.vue?vue&type=script&lang=js"

import "./interest-desc-list.vue?vue&type=style&index=0&id=e28afd9a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28afd9a"]])